import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { MatLegacyMenuTrigger as MatMenuTrigger } from '@angular/material/legacy-menu';
import { MenuAction } from '../../types';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-dropdown-base',
  template: '',
})
export abstract class DropdownBaseComponent implements AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);

  @ViewChild('menuTrigger')
  protected menuTrigger: MatMenuTrigger;

  protected _dirty: boolean;

  get areAllActionsHidden(): boolean {
    return (
      this.menuActions &&
      !this.menuActions.some((action) => !action.displayCondition || action.displayCondition(this.context))
    );
  }

  @HostBinding('class.hidden')
  protected get shouldHideDropdownButton(): boolean {
    return this.shouldHideIfNoMenuActions && this.areAllActionsHidden;
  }

  @HostBinding('class.pointer-events-none')
  protected get shouldDisablePointerEvents(): boolean {
    return !this.shouldHideIfNoMenuActions && this.areAllActionsHidden && !this.shouldBeClickableIfNoMenuActions;
  }

  isOpen: boolean;

  @Input()
  parentMenuTemplate: TemplateRef<any>;

  @Input()
  menuActions: MenuAction[];

  @Input()
  menuOverlayClass: string;

  @Input()
  context: any;

  @Input()
  shouldHideIfNoMenuActions = true;

  @Input()
  shouldBeClickableIfNoMenuActions = false;

  @Output()
  opened: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  closed: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  dirty: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(protected cd: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    if (this.menuTrigger) {
      this.menuTrigger.menuOpened?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.menuOpened());
      this.menuTrigger.menuClosed?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.menuClosed());
    }
  }

  open(): void {
    this.menuTrigger?.openMenu();
  }

  close(): void {
    this.menuTrigger?.closeMenu();
  }

  protected menuOpened(): void {
    this.isOpen = true;

    if (!this._dirty) {
      this.dirty.emit(true);
      this._dirty = true;
    }

    this.opened.emit(true);
    this.cd.detectChanges();
  }

  protected menuClosed(): void {
    if (!this.isOpen) {
      return;
    }

    this.isOpen = false;
    this.closed.emit(true);
    this.cd.detectChanges();
  }
}
